"use strict";

module.exports = require('constants');